import { render, staticRenderFns } from "./coachSkill.vue?vue&type=template&id=35a78af0&scoped=true&"
import script from "./coachSkill.vue?vue&type=script&lang=js&"
export * from "./coachSkill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a78af0",
  null
  
)

export default component.exports